module.exports = __webpack_public_path__ + "static/media/FONDO.f5b2c5f4.jpg";